import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollDefinitionService } from 'app/core/services/payroll-definition.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'dialog-create-periods',
  templateUrl: './dialog-create-periods.component.html',
  styleUrls: ['./dialog-create-periods.component.scss']
})
export class DialogCreatePeriodsComponent implements OnInit {

  isLoading: boolean = false;
  periodForm: FormGroup;

  constructor(public dialogRef: MatDialogRef<DialogCreatePeriodsComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private payrollDefinitionService: PayrollDefinitionService, private toastr: ToastrService) {
    this.periodForm = this.fb.group({
      id: [this.data.id],
      p_AdjustPeriod: [false, Validators.required],
      p_SetoffManual: [true, Validators.required],
      p_Setoff1: [1, Validators.required],
      p_Setoff2: [15, Validators.required],
      p_Setoff3: [16, Validators.required],
      p_Setoff4: [31, Validators.required]
    });

    this.periodForm.get('p_AdjustPeriod')?.valueChanges.subscribe((value: boolean) => {
      if (!value) {
        this.periodForm.get('p_SetoffManual')?.setValidators(Validators.required);
        this.periodForm.get('p_Setoff1')?.setValidators(Validators.required);
        this.periodForm.get('p_Setoff2')?.setValidators(Validators.required);
        this.periodForm.get('p_Setoff3')?.setValidators(Validators.required);
        this.periodForm.get('p_Setoff4')?.setValidators(Validators.required);
      } else {
        this.periodForm.get('p_SetoffManual')?.clearValidators();
        this.periodForm.get('p_Setoff1')?.clearValidators();
        this.periodForm.get('p_Setoff2')?.clearValidators();
        this.periodForm.get('p_Setoff3')?.clearValidators();
        this.periodForm.get('p_Setoff4')?.clearValidators();
      }
  
      this.periodForm.get('p_SetoffManual')?.updateValueAndValidity();
      this.periodForm.get('p_Setoff1')?.updateValueAndValidity();
      this.periodForm.get('p_Setoff2')?.updateValueAndValidity();
      this.periodForm.get('p_Setoff3')?.updateValueAndValidity();
      this.periodForm.get('p_Setoff4')?.updateValueAndValidity();
    });
  }

  ngOnInit(): void {
    this.periodForm.patchValue({
      id: this.data.id
    })
  }

  onNoClick() {
    this.dialogRef.close();
  }

  save() {
    this.isLoading = true;
    if (this.periodForm.invalid) {
      Object.keys(this.periodForm.controls).forEach(controlName => {
        this.periodForm.get(controlName)?.markAsTouched();
      });
      this.isLoading = false;
      return;
    }
    this.payrollDefinitionService.createPeriods(this.periodForm.value).subscribe({
      next: res => {
        if(res.message === "@OK@ Create Periods") {
          window.location.reload();
        } else {
          this.showNotificationError(res.message);
        }
        this.isLoading = false;
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }

  showNotification(text) {
    this.toastr.success('<span class="now-ui-icons ui-1_bell-53"></span> ' + text + '', '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: "alert alert-success alert-with-icon",
      positionClass: 'toast-' + 'top' + '-' + 'center'
    });
  }

  showNotificationError(text) {
    this.toastr.success('<span class="now-ui-icons ui-1_bell-53"></span> ' + text + '', '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: "alert alert-danger alert-with-icon",
      positionClass: 'toast-' + 'top' + '-' + 'center'
    });
  }
}
